import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    houseNumber: {
        id: '_.manual_address.house_number',
        defaultMessage: 'House number'
    },
    houseName: {
        id: '_.manual_address.house_name',
        defaultMessage: 'House name'
    },
    flatNumber: {
        id: '_.manual_address.flat_number',
        defaultMessage: 'Flat number'
    },
    streetLineOne: {
        id: '_.manual_address.street_line_1',
        defaultMessage: 'Street line 1'
    },
    streetLineTwo: {
        id: '_.manual_address.street_line_2',
        defaultMessage: 'Street line 2'
    },
    postcode: {
        id: '_.manual_address.postcode',
        defaultMessage: 'Postcode'
    },
    town: {
        id: '_.manual_address.town',
        defaultMessage: 'Town'
    },
    searchForMyAddress: {
        id: '_.manual_address.search_for_my_address',
        defaultMessage: 'Search for my address'
    }
});
